import { reqMyForm } from '@/routes/ControlPlatform/services';

export default {
  namespace: 'carUseApplyFormList',
  state: {},
  effects: {
    /**
     * 查询我的单据列表
     */
    *reqMyFormList({ payload }, { call }) {
      const res = yield call(reqMyForm, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
